import { authenticate, setUser, setProfile } from './loginSlice';
import { omit, get } from 'lodash';
import api, { normalize } from 'api';
import Cookie from 'js-cookie';

export {
  authenticate
}

const normalizeUserdata = (response) => {
  const normalizedData = normalize(omit(response, 'token'))
  const user = get(normalizedData, `users.${response.data.id}`)
  const profile = get(normalizedData, `operator_profiles.${get(user, 'relationships.profile.data.id')}`)

  return {
    user,
    profile
  }
}

export const login = (email, password, callback) => async dispatch => {

  const response = await api.post('site/authenticate', {
    email, password
  })

  if(response){

    const normalizedData = normalizeUserdata(response)

    await dispatch([
      setUser(normalizedData.user),
      setProfile(normalizedData.profile)
    ])

    await Cookie.set('ltfrb-site:token', response.token , { secure: process.env.NODE_ENV === 'production' })
    await dispatch(authenticate(true))
    if(callback){
      callback()
    }
  }
}


export const validateOtp = (payload, callback) => async dispatch => {

  const response = await api.post('site/validate_otp', payload)

  if(response){

    const normalizedData = normalizeUserdata(response)

    await dispatch([
      setUser(normalizedData.user),
      setProfile(normalizedData.profile)
    ])

    await Cookie.set('ltfrb-site:token', response.token , { secure: process.env.NODE_ENV === 'production' })
    await dispatch(authenticate(true))
    if(callback){
      callback()
    }
  }
}

export const ValidateOtpForgotPassword = (payload, callback) => async dispatch => {

  const response = await api.post('site/forgot_password_validate_otp', payload)

  if(response && callback){
    callback()
  }
}


export const resendOtpForgotPassword = (payload, callback) => async dispatch => {

  const response = await api.post('site/forgot_password_resend_otp', payload)

  if(response && callback){
    callback()
  }
}


export const resendOtp = (payload, callback) => async dispatch => {

  const response = await api.post('site/resend_otp', payload)

  if(response && callback){
    callback()
  }
}


export const forgotPassword = (email,callback) => async dispatch => {

  const response = await api.post('site/forgot_password', {
    email
  })

  if(response){
    if(callback)
      callback()
  }
}


export const forgotPasswordOtp = (mobile_number,callback) => async dispatch => {

  const response = await api.post('site/forgot_password_otp', {
    mobile_number
  })

  if(response){
    if(callback)
      callback()
  }
}



export const verify = (payload,callback) => async dispatch => {

  const response = await api.post('site/verify', payload)

  if(response){
    if(callback)
      callback()
  }
}


export const resetPassword = (payload,callback) => async dispatch => {

  const response = await api.post('site/reset', payload)

  if(response){

    if(callback)
      callback()

  }
}


export const resetPasswordOtp = (payload,callback) => async dispatch => {

  const response = await api.post('site/reset_password_otp', payload)

  if(response){

    if(callback)
      callback()

  }
}

export const logout = () =>  dispatch => {
  Cookie.remove('ltfrb-site:token')
  dispatch(authenticate(false))
}

export const register = (payload, callback) => async () => {

  const reponse = await api.post('site/register', payload)

  if(reponse && callback)
    callback(reponse)
}

export const getProfile = () => async dispatch => {
  const response = await api.get('site/profile')

  if(response){

    const normalizedData = normalizeUserdata(response)

    await dispatch([
      setUser(normalizedData.user),
      setProfile(normalizedData.profile)
    ])
  }
}


export const updateProfile = (payload, callback) => async dispatch => {
  const response = await api.put('site/profile', payload)

  if(response){

    const normalizedData = normalizeUserdata(response)

    await dispatch([
      setUser(normalizedData.user),
      setProfile(normalizedData.profile)
    ])

    if(callback){
      callback(normalizedData)
    }
  }
}


export const updatePhoto = (payload, callback) => async dispatch => {
  const response = await api.put('site/profile/change_photo', payload)

  if(response){

    const normalizedData = normalizeUserdata(response)

    await dispatch([
      setUser(normalizedData.user),
      setProfile(normalizedData.profile)
    ])

    if(callback){
      callback(normalizedData)
    }
  }
}